export default "__VITE_ASSET__DpFKGQNW__"